import { FC, useContext, useEffect } from "react";

import { TeamContext, UserContext, TableContext, SocketContext, BoardContext } from "../../../context";

import { useShowDrawnStrengthCard } from "./helpers";
import { Phase } from "../../../util/enums";
import { IPlayer } from "../../../interfaces";
import { useSound } from "../../../hooks";
import { useTranslation } from "react-i18next";

const BoardMolecule: FC<{}> = () => {
    const { t } = useTranslation();
    const { theSolutionCardSelectedByDilemmaOwner } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const { setTableNotification } = useContext(TableContext);
    const { areSolutionCardsDrawnContext, renderInitialCoins } = useContext(BoardContext);

    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return game.gameInfo.currentPlayerEmail === player.email })
    const dilemmaOwnerNickname = dilemmaOwner?.nickname || "";
    const dilemmaOwnerColor = dilemmaOwner?.color || "";
    const players = game?.gameInfo.players[userData?.email || ""];
    const {playSound} = useSound();

    useShowDrawnStrengthCard(players);

    useEffect(() => {
        if (renderInitialCoins)
            playSound("/sounds/PositiveAlert3.mp3")
    },[playSound, renderInitialCoins]);

    useEffect(() => {
            if (game?.phase === Phase.PICK_DILEMMA && isTheUserDilemaOwner)
                setTableNotification(undefined);
             
            if (game?.phase === Phase.PICK_DILEMMA && !isTheUserDilemaOwner)
                setTableNotification({
                    firstLineBefore: t("itIsText"),
                    firstLineOwner: dilemmaOwnerNickname,
                    ownerColor: dilemmaOwnerColor,
                    firstLineAftar: t("turnToPlayText"),
                    secondLine: t("waitTillTheyPickText"),
                    thirdLine: ""
                });
    }, [dilemmaOwnerColor, dilemmaOwnerNickname, game?.phase, isTheUserDilemaOwner, setTableNotification]);
    
    useEffect(() => {
            if (game?.phase === Phase.QUESTION_CARD && isTheUserDilemaOwner)
                setTableNotification({
                    firstLineBefore: t("youPickedAQuestionCard"),
                    firstLineOwner: "",
                    ownerColor: "",
                    firstLineAftar: "",
                    secondLine: t("teamAndWaitForThemText"),
                    thirdLine: t("andEloborateOnTheirIdeas")
                });

            if (game?.phase === Phase.QUESTION_CARD && !isTheUserDilemaOwner)
                setTableNotification({
                    firstLineBefore: "",
                    firstLineOwner: dilemmaOwnerNickname,
                    ownerColor: dilemmaOwnerColor,
                    firstLineAftar: t("pickedAQuestionCardText"),
                    secondLine: t("solutionCardFromYourHandText"),
                    thirdLine: t("explainWhyYouThinkThatIsTheBestSolutionText")
                });
    }, [dilemmaOwnerColor, dilemmaOwnerNickname, game?.phase, isTheUserDilemaOwner, setTableNotification]);
    
    useEffect(() => {
            if (game?.phase === Phase.ACTION_CARD && isTheUserDilemaOwner)
                setTableNotification({
                    firstLineBefore: t("youPickedAnActionCard"),
                    firstLineOwner: "",
                    ownerColor: "",
                    firstLineAftar: "",
                    secondLine: t("readItOutLoudText"),
                    thirdLine: t("clickDoneText")
                });
            
            if (game?.phase === Phase.ACTION_CARD && !isTheUserDilemaOwner)
                setTableNotification({
                    firstLineBefore: "",
                    firstLineOwner: dilemmaOwnerNickname,
                    ownerColor: dilemmaOwnerColor,
                    firstLineAftar: t("pickedAnActionCardText"),
                    secondLine: t("helpByBrainstormingText"),
                    thirdLine: t("discussTheTopicText")
                });
    }, [dilemmaOwnerColor, dilemmaOwnerNickname, game?.phase, isTheUserDilemaOwner, setTableNotification]);
    
    useEffect(() => {

        if (game?.phase === Phase.CHOOSING_SOLUTION_CARDS && areSolutionCardsDrawnContext)
            setTableNotification({
                firstLineBefore:  t("waitForTheOtherUsersText"),
                firstLineOwner: "",
                ownerColor: "",
                firstLineAftar: "",
                secondLine: t("initialSolutionCardsText"),
                thirdLine: ""
            });

    }, [areSolutionCardsDrawnContext, game?.phase, setTableNotification]);
    
    useEffect(() => {
            if (game?.phase === Phase.CHOOSE_SOLUTION && isTheUserDilemaOwner) 
                setTableNotification({
                    firstLineBefore:  t("theSolutionCardsAreProposedText"),
                    firstLineOwner: "",
                    ownerColor: "",
                    firstLineAftar: "",
                    secondLine: t("doubleClickOnTheSolutionText"),
                    thirdLine: ""
                });
            
            if (game?.phase === Phase.CHOOSE_SOLUTION && !isTheUserDilemaOwner && !theSolutionCardSelectedByDilemmaOwner) 
                setTableNotification({
                    firstLineBefore: t("goAroundTheTableText"),
                    firstLineOwner: dilemmaOwnerNickname,
                    ownerColor: dilemmaOwnerColor,
                    firstLineAftar: "",
                    secondLine: "",
                    thirdLine: ""
                });

            if (game?.phase === Phase.CHOOSE_SOLUTION && !isTheUserDilemaOwner && theSolutionCardSelectedByDilemmaOwner)
                setTableNotification({
                    firstLineBefore: t("nowWaitForText"),
                    firstLineOwner: dilemmaOwnerNickname,
                    ownerColor: dilemmaOwnerColor,
                    firstLineAftar: t("toChoosesAstrenghtCardText"),
                    secondLine: "",
                    thirdLine: ""
                });
    }, [dilemmaOwnerColor, dilemmaOwnerNickname, game?.phase, isTheUserDilemaOwner, setTableNotification, theSolutionCardSelectedByDilemmaOwner]);
    
    useEffect(() => {
        if (game?.phase === Phase.CONFETTI_CELEBRATION || game?.phase === Phase.SOLUTION_CHOSEN || game?.phase === Phase.SOLUTION_CHOSEN_REWARD ) {
            if (isTheUserDilemaOwner) 
                setTableNotification(undefined);
            
            if (!isTheUserDilemaOwner)
                setTableNotification(undefined);
        }
    }, [game?.phase, isTheUserDilemaOwner, setTableNotification]);

    return (
        <div></div>
    );
};

export default BoardMolecule